/** PV-Verbrauch: >2700 kWh + 12 Monate; 2300–2700 kWh nur mit Realisierung in 3 Monaten (ohne 12-Monats-Frage) */

export const CONSUMPTION_OVER_2700_THRESHOLD = 2700;

export const isYearlyConsumptionOver2700Valid = (value) => {
  const amount = Number(value);
  return value !== '' && !Number.isNaN(amount) && amount > CONSUMPTION_OVER_2700_THRESHOLD;
};

export const hasQualifyingPvConsumption = (data) => {
  if (
    data.consumptionOver2700 === true &&
    isYearlyConsumptionOver2700Valid(data.yearlyConsumption) &&
    data.hasRealizationTimeframe === true
  ) {
    return true;
  }
  if (data.consumptionOver2700 === false && data.consumptionInRangeWith3Months === true) {
    return true;
  }
  return false;
};

export const isPvConsumptionStepComplete = (data) => {
  if (data.consumptionOver2700 === null) return false;
  if (data.consumptionOver2700 === true) {
    return (
      isYearlyConsumptionOver2700Valid(data.yearlyConsumption) &&
      data.hasRealizationTimeframe !== null
    );
  }
  return data.consumptionInRangeWith3Months !== null;
};

/** Alias für ältere Formular-Referenzen nach der kWh-Umstellung */
export const hasQualifyingElectricityCosts = isPvConsumptionStepComplete;

export const isPvConsumptionDisqualified = (data) => {
  if (data.consumptionOver2700 === false && data.consumptionInRangeWith3Months === false) {
    return true;
  }
  if (data.consumptionOver2700 === true && data.hasRealizationTimeframe === false) {
    return true;
  }
  if (
    data.consumptionOver2700 === true &&
    data.yearlyConsumption !== '' &&
    !isYearlyConsumptionOver2700Valid(data.yearlyConsumption)
  ) {
    return true;
  }
  return false;
};

export const getQualifiedBannerMinProgression = (data) => {
  if (data.consumptionInRangeWith3Months === true) return 11;
  return 13;
};

export const getPvConsumptionSubmitValues = (data) => ({
  yearlyConsumptionOver2200: hasQualifyingPvConsumption(data),
  yearlyConsumption: data.yearlyConsumption || '',
  hasRealizationTimeframe:
    data.consumptionInRangeWith3Months === true ? true : data.hasRealizationTimeframe
});

const isStoredPvQualified = (stored = {}) =>
  stored.jahresverbrauch_2200_kwh === 'Ja' ||
  stored.yearlyConsumptionOver2200 === 1 ||
  stored.yearlyConsumptionOver2200 === true;

const getStoredYearlyKwh = (stored = {}) => {
  const raw = stored.yearlyConsumption ?? stored.jahresverbrauch ?? '';
  if (raw === '' || raw == null) return null;
  const amount = Number(raw);
  return Number.isNaN(amount) ? null : amount;
};

/** Gespeicherte Lead-Daten → Anzeige „kWh-Verbrauch > 2700?“ */
export const getPvConsumptionOver2700Display = (stored = {}) => {
  const kwh = getStoredYearlyKwh(stored);
  if (kwh !== null) {
    return kwh > CONSUMPTION_OVER_2700_THRESHOLD ? 'Ja' : 'Nein';
  }
  if (isStoredPvQualified(stored)) return 'Nein';
  if (
    stored.jahresverbrauch_2200_kwh === 'Nein' ||
    stored.yearlyConsumptionOver2200 === 0 ||
    stored.yearlyConsumptionOver2200 === false
  ) {
    return 'Nein';
  }
  return null;
};

/** Gespeicherte Lead-Daten → Anzeige „2300–2700 + 3 Monate“ */
export const getPvConsumptionRange3MonthsDisplay = (stored = {}) => {
  const kwh = getStoredYearlyKwh(stored);
  const over2700 = kwh !== null && kwh > CONSUMPTION_OVER_2700_THRESHOLD;
  const qualified = isStoredPvQualified(stored);

  if (qualified && !over2700) return 'Ja';
  if (
    stored.jahresverbrauch_2200_kwh === 'Nein' ||
    stored.yearlyConsumptionOver2200 === 0 ||
    stored.yearlyConsumptionOver2200 === false
  ) {
    return 'Nein';
  }
  if (qualified && over2700) return 'Nein';
  return null;
};

export const getPvConsumptionDisplayFields = (stored = {}) => ({
  verbrauchUeber2700: getPvConsumptionOver2700Display(stored),
  verbrauch2300_2700_3Monate: getPvConsumptionRange3MonthsDisplay(stored)
});
